import {OktaAuth} from '@okta/okta-auth-js';

export const oktaConfig = {
    clientId: process.env.REACT_APP_CLIENT_ID,
    issuer: 'https://signin.kering.com/oauth2/default',
    redirectUri: process.env.REACT_APP_BASE_URL,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
    tokenManager: {
        autoRenew: true,
        storage: 'sessionStorage'
    }
};

export const oktaAuthInstance = new OktaAuth(oktaConfig);
